"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pick_1 = __importDefault(require("lodash/pick"));
const next_i18next_1 = require("next-i18next");
const react_1 = __importDefault(require("react"));
const libs_utils_1 = require("@hotelplan/libs.utils");
const gradientRatio = 2;
const SVG_PROPS = [
    `className`,
    `style`,
    `viewBox`,
    `color`,
    `min`,
    `max`,
    `lang`,
    `media`,
    `target`,
    `type`,
    `fill`,
    `fillOpacity`,
    `fillRule`,
    `preserveAspectRatio`,
];
const PlaceholderLoader = props => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const { loading = true, uid: uniqueKey, children, title = t('loading'), bgColor = '#f5f6f7', fgColor = '#eee', speed = 2, } = props;
    const fixedId = uniqueKey || (0, libs_utils_1.uid)();
    const idClip = `${fixedId}-diff`;
    const idGradient = `${fixedId}-animated-diff`;
    const idAria = `${fixedId}-aria`;
    const keyTimes = `0; 0.25; 1`;
    const dur = `${speed}s`;
    const svgProps = (0, pick_1.default)(props, SVG_PROPS);
    return (react_1.default.createElement("svg", Object.assign({ role: "img", "aria-labelledby": idAria, viewBox: `0 0 ${props.width} ${props.height}` }, svgProps),
        title && loading ? react_1.default.createElement("title", { id: idAria }, title) : null,
        loading ? (react_1.default.createElement("rect", { role: "presentation", x: "0", y: "0", width: "100%", height: "100%", clipPath: `url(#${idClip})`, style: { fill: `url(#${idGradient})` } })) : null,
        loading ? (react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: idClip }, children),
            react_1.default.createElement("linearGradient", { id: idGradient },
                react_1.default.createElement("stop", { offset: "0%", stopColor: bgColor, stopOpacity: 1 },
                    react_1.default.createElement("animate", { attributeName: "offset", values: `${-gradientRatio}; ${-gradientRatio}; 1`, keyTimes: keyTimes, dur: dur, repeatCount: "indefinite" })),
                react_1.default.createElement("stop", { offset: "50%", stopColor: fgColor, stopOpacity: 1 },
                    react_1.default.createElement("animate", { attributeName: "offset", values: `${-gradientRatio / 2}; ${-gradientRatio / 2}; ${1 + gradientRatio / 2}`, keyTimes: keyTimes, dur: dur, repeatCount: "indefinite" })),
                react_1.default.createElement("stop", { offset: "100%", stopColor: bgColor, stopOpacity: 1 },
                    react_1.default.createElement("animate", { attributeName: "offset", values: `0; 0; ${1 + gradientRatio}`, keyTimes: keyTimes, dur: dur, repeatCount: "indefinite" }))))) : (children)));
};
exports.default = PlaceholderLoader;
//# sourceMappingURL=PlaceholderLoader.js.map